import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../shared/services/shared.service';

import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-play-golf-landing',
    imports: [
    TranslatePipe
],
    templateUrl: './play-golf-landing.component.html',
    styleUrl: './play-golf-landing.component.scss'
})
export class PlayGolfLandingComponent implements OnInit {
  isLoggedIn = false;
  private _authService = inject(AuthService);
  private _router = inject(Router);
  ngOnInit(): void {
     this.isLoggedIn = this._authService.isSignedIn();
  }
  openAuthModal(type = 'login') {
    this._router.navigate([type]);
  }
}
